import * as Yup from 'yup'

const deleteProfileSchema = Yup.object().shape({
  delete: Yup.string()
    .oneOf(['delete'], 'validation-delete-confirm')
    .required('validation-delete-confirm'),
})

export { deleteProfileSchema }
